import _classCallCheck from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var Remove = /*#__PURE__*/function () {
  function Remove() {
    _classCallCheck(this, Remove);

    this.quantity = 2;
  }

  _createClass(Remove, [{
    key: "particles_nb",
    get: function get() {
      return this.quantity;
    },
    set: function set(value) {
      this.quantity = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;

      if (data === undefined) {
        return;
      }

      var quantity = (_a = data.quantity) !== null && _a !== void 0 ? _a : data.particles_nb;

      if (quantity !== undefined) {
        this.quantity = quantity;
      }
    }
  }]);

  return Remove;
}();